import axios from 'axios';
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class NotificationService {
    async getNotificationList(notification_title, notification_type, start_date, end_date) {
        return await axios
            .post(`/notification/all`, {
                notification_title: notification_title,
                notification_type: notification_type,
                start_date: start_date,
                end_date: end_date,
            })
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }

    async productCategory() {
        return await axios
            .get(`/category`)
            .then((res) => res.data.categoryData)
            .catch((err) => {
                errCheck(err);
            });
    }

    async NotificationDetails(ids, notification_type) {
        return await axios
            .post(`/notification/details`, {
                notification_id: ids,
                notification_type: notification_type,
            })
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async getExcel(notification_title, notification_type, start_date, end_date,dreason) {
        return await axios({
            url: `/notification/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                notification_title: notification_title,
                notification_type: notification_type,
                start_date: start_date,
                end_date: end_date,
                reason:dreason,
            },
        })
            .then((res) => res)
            .catch((err) => {
                errCheck(err);
            });
    }
}
